export const SUMMARY_TITLE = "Summary"

export const DASHBOARD_TOOLBAR_TITLE = "Dashboard"
export const REFRESH_TITLE = "Refresh Dashboard"
export const SERVER_FAILED_ERROR_MESSAGE = "Server Failed";